import React from 'react'

import Form from 'react-bootstrap/Form'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Button from 'react-bootstrap/Button'

import { InfoIcon } from '../../InfoIcon'
import { RequiredText } from '../../RequiredText'
import { DateTime } from './DateTime'

export default function Details({
  requiredFieldErrorStatus,
  flexPack,
  start,
  setStart,
  end,
  setEnd,
  handleChange,
  endTimeError,
  endTimeErrorMsg,
  isEditable,
}) {
  return (
    <>
      <Form.Group className="form-group" controlId="name">
        <div className="form-label--flex">
          <Form.Label>Name</Form.Label>
          <OverlayTrigger
            placement="right"
            overlay={
              <Tooltip>
                Maximum 100 characters. No HTML or emoji allowed
              </Tooltip>
            }
          >
            <Button variant="link">
              <InfoIcon />
            </Button>
          </OverlayTrigger>
          {requiredFieldErrorStatus?.name && <RequiredText />}
        </div>
        <Form.Control
          type="text"
          name="name"
          placeholder="Enter flex package name"
          disabled={!isEditable}
          maxLength="100"
          defaultValue={flexPack?.name}
          onChange={handleChange}
          required
          className={requiredFieldErrorStatus?.name ? 'error-border' : ''}
        />
      </Form.Group>
      <Form.Group className="form-group" controlId="price">
        <div className="form-label--flex">
          <Form.Label>Price</Form.Label>
          {requiredFieldErrorStatus?.price && <RequiredText />}
        </div>
        <Form.Control
          placeholder="Amount"
          pattern="^[0-9.]*$"
          name="price"
          disabled={!isEditable}
          onChange={(e) =>
            handleChange(
              e.target.value === '' || e.target.validity.valid
                ? e
                : flexPack?.price
            )
          }
          value={flexPack?.price ?? ''}
          className={requiredFieldErrorStatus?.price ? 'error-border' : ''}
        />
        <Form.Text className="text-muted">
          {Number(flexPack?.price) === 0
            ? 'Sponsored/comp flex packs with $0 price do not incur per-voucher fees.'
            : 'Includes a $1 Blocktickets service fee per voucher at checkout.'}
        </Form.Text>
      </Form.Group>
      <Form.Group className="form-group" controlId="gameTickets">
        <div className="form-label--flex">
          <Form.Label>Number of vouchers included</Form.Label>
          {requiredFieldErrorStatus?.gameTickets && <RequiredText />}
        </div>
        <Form.Control
          name="gameTickets"
          placeholder="Number of vouchers included"
          pattern="^[0-9]*$"
          disabled={!isEditable}
          value={flexPack?.gameTickets ?? ''}
          onChange={(e) =>
            handleChange(
              e.target.value === '' || e.target.validity.valid
                ? e
                : flexPack?.gameTickets
            )
          }
          className={
            requiredFieldErrorStatus?.gameTickets ? 'error-border' : ''
          }
        />
      </Form.Group>
      <Form.Group className="form-group" controlId="qtyAvailable">
        <div className="form-label--flex">
          <Form.Label>Max available</Form.Label>
          <OverlayTrigger
            placement="right"
            overlay={
              <Tooltip>
                Optional limit on how many flex packages can be sold online.
                Leave blank for unlimited availability.
              </Tooltip>
            }
          >
            <Button variant="link">
              <InfoIcon />
            </Button>
          </OverlayTrigger>
        </div>
        <Form.Control
          name="qtyAvailable"
          placeholder="Unlimited"
          pattern="^[0-9]*$"
          disabled={!isEditable}
          value={flexPack?.qtyAvailable ?? ''}
          onChange={(e) =>
            handleChange(
              e.target.value === '' || e.target.validity.valid
                ? e
                : flexPack?.qtyAvailable
            )
          }
        />
      </Form.Group>
      <Form.Group className="form-group" controlId="description">
        <div className="form-label--flex">
          <Form.Label>Description</Form.Label>
          <OverlayTrigger
            placement="right"
            overlay={<Tooltip>Add information about this flex package</Tooltip>}
          >
            <Button variant="link">
              <InfoIcon />
            </Button>
          </OverlayTrigger>
        </div>
        <Form.Control
          as="textarea"
          rows={5}
          name="description"
          disabled={!isEditable}
          placeholder="Add description for this flex package"
          value={flexPack?.description || ''}
          onChange={handleChange}
        />
      </Form.Group>
      <DateTime
        start={start}
        setStart={setStart}
        end={end}
        setEnd={setEnd}
        endTimeError={endTimeError}
        endTimeErrorMsg={endTimeErrorMsg}
        isEditable={isEditable}
      />
    </>
  )
}
